import { get, post } from '../../utils/shared/api';

class ContentProvider {
  constructor(contentId, baseUrl, format) {
    this.contentId = contentId;
    this.baseUrl = baseUrl;
    this.format = format;
  }

  async save(commit) {
    await post(
      `${this.baseUrl}?type=commit`,
      JSON.stringify({
        commit: {
          ...commit,
          contentId: this.contentId
        }
      }),
      false
    );
  }

  async goToVersion(activeVersionIndex, versions, historyMode) {
    const version = versions[activeVersionIndex];
    let url;
    if (historyMode) {
      const versionTimestamp = version.end ? version.end : new Date().toJSON();
      const prevVersion = versions.length > 1 ? versions[activeVersionIndex - 1] : null;
      const prevVersionTimestamp =
        prevVersion && prevVersion.end ? prevVersion.end : new Date(null).toJSON();

      url = `${this.baseUrl}/${this.contentId}?type=doc&compareTimestamp=${prevVersionTimestamp}&docTimestamp=${versionTimestamp}`;
    } else {
      url = `${this.baseUrl}/${this.contentId}?type=doc`;
    }
    const response = await get(url, false);

    return Promise.resolve(response);
  }

  async load() {
    let response;
    const trackState = null;
    try {
      response = await get(`${this.baseUrl}/${this.contentId}?type=doc`, false);
      return Promise.resolve({
        state: {
          doc: response.doc,
          selection: { type: 'text', anchor: 1, head: 1 }
        },
        trackState
      });
    } catch (err) {
      let returned;
      // if content not found, send post request to create a new one
      if (err.response.status === 404) {
        response = await post(
          `${this.baseUrl}?type=content`,
          JSON.stringify({ content: { id: this.contentId, format: this.format } }),
          false
        );
        returned = Promise.resolve({
          state: response,
          trackState
        });
      } else {
        returned = err;
      }
      return returned;
    }
  }
}

export default ContentProvider;



// WEBPACK FOOTER //
// ./app/javascript/client/utils/contentProvider.js